// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { CartBonuses } from '../../components/CartBonuses';
import InputSelect from '../../components/InputSelect';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Helmet } from 'react-helmet';
import { PICS_URL } from '../../api';
import OrderPackichQuote from '../../components/quote/order_quote';
import { format_price } from '../../js/utils';
import { IMaskInput } from 'react-imask';
import '../../styles/cart.css';
import { useNavigate } from 'react-router';
import { ROUTES_PATHS } from 'const';
import { Link } from 'react-router-dom';
import dotImage from '../../assets/icons/cart-reg-dot.svg';
import { useStores } from 'hooks/useStores';
import { CartRegSchema } from './schema';
import { getPluralString } from 'utils';
import { observer } from 'mobx-react';
import { EmptyIcon } from 'components/Cards/ProductCard/components/EmptyIcon';

const CartReg = observer(() => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoadedTotal, setIsLoadedTotal] = useState(false);
  const { api, cartStore } = useStores();

  const {
    getCart,
    cartInfo,
    cartItems,
    totalItems,
    removeCartItem,
    getCartItems,
    clearCart,
  } = cartStore;

  // основное получение списка товаров
  useEffect(() => {
    setIsLoaded(false);
    getCartItems().then(() => setIsLoaded(true));
  }, []);

  // получение итогового окна
  useEffect(() => {
    getCart().then(() => setIsLoadedTotal(true));
  }, []);

  // удаление товара

  const handleDeleteItem = (cartItemId) => {
    removeCartItem(cartItemId).then(() => getCart());
  };
  // ----------------------

  //  форма
  const [fileName, setFileName] = useState('');
  const [city, setCity] = useState('Москва');
  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    mode: 'onBlur',
    resolver: yupResolver(CartRegSchema),
  });

  const [currentUser, setCurrentUser] = useState({
    company: '',
    email: '',
    first_name: '',
    last_name: '',
    phone: '',
    position: '',
    username: '',
  });
  const [isLoadedCurrentUser, setIsLoadedCurrentUser] = useState(false);

  useEffect(() => {
    api.user
      .getCurrentUser()
      .then((res) => {
        setCurrentUser(res);
        setIsLoadedCurrentUser(true);
      })
      .catch((error) => {
        if (error.response.status === 500) {
          throw new Error();
        }
      });
  }, []);

  useEffect(() => {
    if (isLoadedCurrentUser) {
      setValue('customer_company_name', currentUser.company);
      setValue('customer_name', currentUser.first_name);
      setValue('customer_email', currentUser.email);
      setValue('phone', currentUser.phone.split('').slice(0).join(''));
    }
  }, [isLoadedCurrentUser]);

  const onSubmit = (data) => {
    const file = document.getElementById('input__file').files[0];
    const newData = new FormData();
    if (file) {
      newData.append('customer_company_requisites', file);
    }
    newData.append('customer_name', data.customer_name);
    newData.append('customer_email', data.customer_email);
    newData.append('customer_phone', data.phone);
    newData.append('customer_company_name', data.customer_company_name);

    newData.append('customer_locality', city);
    newData.append('comment', data.comment);

    api.order.postOrder(newData).then((response) => {
      if (response && response.id) {
        if (typeof window.ym !== 'undefined') {
          window.ym(89149994, 'reachGoal', 'popup_zakazotpravlen');
        }
      }
      clearCart();
      buttonSendCart();
    });
  };

  const buttonSendCart = () => {
    document.querySelector('.button-addToCart-main').style.display = 'none';
    document.querySelector('.button-addToCart-loader').style.display = 'flex';

    setTimeout(() => {
      document.querySelector('.button-addToCart-loader').style.display = 'none';
      document.querySelector('.button-addToCart-added').style.display = 'flex';
    }, 1400);
    setTimeout(() => {
      document.querySelector('.cart-complete-modal').style.display = 'flex';
    }, 1600);
  };

  const town = [
    { value: 'first', label: 'Москва' },
    { value: 'second', label: 'Московская Область' },
  ];

  const [fileErr, setFileErr] = useState(false);

  const fileHandler = () => {
    let size = (
      document.getElementById('input__file').files[0].size / 1000000
    ).toFixed(1);
    if (document.body.clientWidth < 800) {
      let file = document.getElementById('input__file').files[0].name;
      if (file.length > 11) {
        let shortFile = file.split('').slice(0, 10).join('');
        let dots = '...';
        setFileName(shortFile + dots);
        return;
      }
      setFileName(file);
    } else {
      setFileName(document.getElementById('input__file').files[0].name);
    }
    if (size > 5) {
      setFileErr(true);
      document.getElementById('input__file').value = '';
    } else {
      setFileErr(false);
    }
  };

  const deleteFile = () => {
    document.getElementById('input__file').value = '';
    setFileName('');
    setFileErr(false);
  };
  useEffect(() => {
    if (fileErr) {
      document.querySelector('.total-button-addToCart').disabled = true;
    } else {
      document.querySelector('.total-button-addToCart').disabled = false;
    }
  }, [fileErr]);

  const cityHandler = (value) => {
    setCity(value.label);
  };

  // ----------------------

  const navigate = useNavigate();

  const backToCartHandler = () => {
    navigate(ROUTES_PATHS.CART);
  };

  const [agreement, setAgreement] = useState('');

  useEffect(() => {
    api.content.getPageApi('glavnaya').then((res) => {
      setAgreement(res.init_state.agreement);
    });
  }, []);

  const [context, setContext] = useState({});
  useEffect(() => {
    api.content
      .getPageApi('cart-reg')
      .then((response) => {
        setContext(response.init_state.object);
      });
  }, []);

  return (
    <main>
      <section className="cart">
        <div className="cart-wrap">
          <Helmet>
            <meta charSet="utf-8" />
            <title>{context.seo_title}</title>
            <meta name="keywords" content={context.seo_keywords} />
            <meta name="description" content={context.seo_description} />
          </Helmet>
          <button onClick={backToCartHandler} className="button-backtoCart">
            <div className="button-backtoCart-icon"></div>
            <div className="button-backtoCart-title">Вернуться в корзину</div>
          </button>
          <h1 className="cart-title">Оформление заказа</h1>
          <div className="cart-content">
            <div className="cart-content-reg">
              <form className="cart-form">
                <div className="cart-form__item">
                  <div className="cart-form__title">
                    Имя<span>*</span>
                  </div>
                  <div>
                    <input
                      {...register('customer_name')}
                      id="customer_name"
                      name="customer_name"
                      type="text"
                      className="cart-form__input cart-form__input-name"
                      maxLength="50"
                    />
                    <p className="cart-form__err">
                      {errors.customer_name?.message}
                    </p>
                  </div>
                </div>

                <div className="cart-form__item">
                  <div className="cart-form__title">Компания:</div>
                  <div className="company-data-css">
                    <input
                      {...register('customer_company_name')}
                      id="customer_company_name"
                      name="customer_company_name"
                      type="text"
                      className="cart-form__input"
                      maxLength="50"
                    />
                    <div className="cart-form-fileAdd-buttons">
                      <label>
                        <div className="fileAdd-buttonAdd">
                          Загрузить реквизиты
                        </div>
                        <div style={{ display: 'none' }}>
                          <input
                            type="file"
                            name="file"
                            id="input__file"
                            className="cart-form-input__file"
                            onChange={fileHandler}
                          />
                        </div>
                      </label>
                      {fileName === '' ? (
                        <div className="fileAdd-buttonAdded">
                          файл не выбран
                        </div>
                      ) : (
                        <div className="fileAdd-buttonAdded fileAdd-fileName">
                          {fileName}

                          <div
                            onClick={deleteFile}
                            className="fileAdd-deleteFile"
                          ></div>
                        </div>
                      )}
                    </div>
                    <p className="cart-form-file-descr">
                      Принимаются файлы до 5 МБ.
                    </p>
                    {fileErr && (
                      <p className="cart-form__err">
                        файл слишком большой, загрузите файл меньше
                      </p>
                    )}
                  </div>
                </div>

                <div className="cart-form__item">
                  <div className="cart-form__title">
                    Электронная почта<span>*</span>
                  </div>
                  <div>
                    <input
                      {...register('customer_email')}
                      name="customer_email"
                      type="text"
                      className="cart-form__input"
                      maxLength="50"
                    />
                    <p className="cart-form__err">
                      {errors.customer_email?.message}
                    </p>
                  </div>
                </div>

                <div className="cart-form__item">
                  <label htmlFor="phone" className="cart-form__title">
                    Телефон<span>*</span>
                  </label>
                  <div>
                    <Controller
                      render={({ field: { onChange, value } }) => (
                        <IMaskInput
                          className="cart-form__input"
                          mask={'+{7} 000 000-00-00'}
                          unmask={true}
                          value={value}
                          placeholder="+7 (___)"
                          onAccept={(val) => onChange(val)}
                        />
                      )}
                      id="phone"
                      name="phone"
                      type="tel"
                      control={control}
                    />
                    <p className="cart-form__err">{errors.phone?.message}</p>
                  </div>
                </div>

                <div className="cart-form__item">
                  <div className="cart-form__title">
                    Населенный пункт<span>*</span>
                  </div>
                  <div className="cart-form-inputSelect">
                    <InputSelect
                      defaultValue={town[0]}
                      options={town}
                      onchangeInput={cityHandler}
                    />
                  </div>
                </div>

                <div className="cart-form__item">
                  <div className="cart-form__title">Комментарий</div>
                  <div>
                    <textarea
                      {...register('comment')}
                      name="comment"
                      type="text"
                      className="cart-form__input cart-form__input-comment"
                    />
                  </div>
                </div>
              </form>
              <div className="cart-content__goods">
                <div className="goods-wrap">
                  <div className="goods-table-heading">
                    <h3 className="items-count-js">
                      {totalItems}{' '}
                      {getPluralString(
                        ['Товар', 'Товара', 'Товаров'],
                        totalItems,
                      )}
                    </h3>
                    <div className="goods-table-heading-items">
                      <p className="goods-table-heading-count">Количество</p>
                      <p className="goods-table-heading-price">Цена</p>
                    </div>
                  </div>
                  <div className="goods-border"></div>
                  <div className="goods-items">
                    {isLoaded
                      ? totalItems !== 0
                        ? cartItems.map((item, i) => (
                            <div
                              key={item.cart_item_id}
                              id={i}
                              className="goods-item"
                            >
                              <div className="item-wrap">
                                <div className="item-image">
                                  {item.product.image === null ? (
                                    <EmptyIcon minHeight="44px" />
                                  ) : (
                                    <img loading="lazy"
                                      src={item.product.image}
                                      alt={item.product.title}
                                    />
                                  )}
                                </div>
                                <div className="item-text">
                                  <p>{item.product.title}</p>
                                  {item.product.in_stock == 'в наличии' ||
                                  item.product.in_stock == 'В наличии' ? (
                                    <p className="cart-inStock">
                                      {item.product.in_stock}
                                    </p>
                                  ) : (
                                    <p className="cart-outStock">
                                      {item.product.in_stock}
                                    </p>
                                  )}
                                </div>
                                <div className="item-counters-registration">
                                  {item.package_quantity === 0 ? (
                                    <div className="item-counters-registration item-counters-reg">
                                      <p>{item.item_quantity} шт.</p>
                                    </div>
                                  ) : (
                                    <div className="item-counters-registration item-counters-reg">
                                      <p>{item.package_quantity} коробка(ок)</p>
                                      <img loading="lazy"
                                        src={dotImage}
                                        width="6px"
                                        height="20px"
                                        alt=""
                                      />
                                      <p>{item.item_quantity} шт.</p>
                                    </div>
                                  )}
                                </div>
                                <div className="item-price">
                                  <div className="item-price-total">
                                    {format_price(item.total_price)} ₽
                                  </div>
                                  <div className="item-prices">
                                    <div className="item-price-max">
                                      {format_price(item.old_price)} ₽/шт.
                                    </div>
                                    <div className="item-price-perOne">
                                      {format_price(item.new_price)} ₽/шт.
                                    </div>
                                  </div>
                                </div>
                                <button
                                  onClick={() =>
                                    handleDeleteItem(item.cart_item_id)
                                  }
                                  className="item-arrow"
                                ></button>
                              </div>
                              {i + 1 != totalItems ? (
                                <div className="item-border"></div>
                              ) : null}
                            </div>
                          ))
                        : null
                      : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="cart-content__total">
              <div className="total-wrap">
                <div className="total-main">
                  <div className="total-heading">
                    <h3>Итого</h3>
                    {isLoadedTotal ? (
                      <h3>{format_price(cartInfo.total)} ₽</h3>
                    ) : null}
                  </div>
                  <h4 className="total-heading-NDS">
                    Цены указаны с учетом НДС
                  </h4>
                  {isLoadedTotal && cartInfo.bonuses_count > 0 && (
                    <CartBonuses amount={cartInfo.bonuses_count} />
                  )}
                  <div className="total-border"></div>
                  <div className="total-shipping total-shipping-cart-reg">
                    <div className="total-goods-counter">
                      <div className="total-goods-counter-title">Товары</div>
                      <div className="total-goods-counter-count">
                        ({totalItems})
                      </div>
                    </div>
                    <div className="total-goods-shipType">
                      <div className="total-goods-counter-title">Доставка</div>
                      {cartInfo.delivery ? (
                        <div className="total-goods-shipType-title">
                          По адресу
                        </div>
                      ) : (
                        <div className="total-goods-shipType-type">
                          Самовывоз
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="total-border"></div>
                  <div className="total-polite">
                    Нажимая на кнопку «отправить», соглашаюсь c &nbsp;
                    <span className="total-polite-link">
                      <a href={agreement} target="_blank" rel="noreferrer">
                        Условиями обработки персональных данных
                      </a>
                    </span>
                  </div>
                  <button
                    className="total-button-addToCart"
                    onClick={handleSubmit(onSubmit)}
                  >
                    <div className="button-addToCart-main">
                      <div className="total-button-title">Отправить</div>
                    </div>

                    <div className="button-addToCart-loader">
                      <div className="button-addToCart-loader__circle cart__circle1"></div>
                      <div className="button-addToCart-loader__circle cart__circle2"></div>
                      <div className="button-addToCart-loader__circle cart__circle3"></div>
                    </div>

                    <div className="button-addToCart-added">
                      <div className="button-addToCart-icon-added"></div>
                    </div>
                  </button>
                </div>
              </div>
              {context.pak_pakych_quote ? (
                <OrderPackichQuote
                  text={context.pak_pakych_quote.text}
                  bgColor={context.pak_pakych_quote.bg_color}
                  borderColor={context.pak_pakych_quote.border_color}
                />
              ) : null}
            </div>
          </div>

          <div className="cart-complete-modal">
            <div className="cart-complete-modal-packich"></div>
            <div className="cart-complete-modal-content">
              <Link
                to={ROUTES_PATHS.MAIN}
                className={'cart-complete-modal__close'}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.46 12L19 17.54L18 18.5L17.54 19L12 13.46L6.46 19L5.5 18L5 17.54L10.54 12L5 6.46L6 5.5L6.46 5L12 10.54L17.54 5L18.5 6L19 6.46L13.46 12Z"
                    fill="#222222"
                  />
                </svg>
              </Link>
              <div className="cart-complete-modal__bubble">
                <p className="cart-complete-modal__bubble-text">
                  Заказ отправлен. <br /> В ближайшее время мы <br /> свяжемся с
                  Вами <br /> для уточнения деталей
                </p>
                <Link
                  to={ROUTES_PATHS.MAIN}
                  className="total-button-addToCart cart-complete-modal__bubble-button"
                >
                  Ладненько
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
});

export default CartReg;
